import { render, staticRenderFns } from "./Pembelian.vue?vue&type=template&id=78fb818a&scoped=true&"
import script from "./Pembelian.vue?vue&type=script&lang=js&"
export * from "./Pembelian.vue?vue&type=script&lang=js&"
import style0 from "./Pembelian.vue?vue&type=style&index=0&id=78fb818a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb818a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VIcon,VSheet,VSpacer,VTab,VTabItem,VTabs})
